import { Mail, MapPin, Clock3 } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CARDS = [
  {
    icon: Mail,
    title: "Email करें",
    lines: [
      { text: "support@ishukart.com", href: "mailto:support@ishukart.com", testid: "contact-email-link" },
      { text: "Bookings, refunds और test drives — सबके लिए एक email। 24–48 घंटे में जवाब।", href: null, testid: null },
    ],
  },
  {
    icon: MapPin,
    title: "Experience Centre",
    lines: [
      { text: "IshuKart Experience Centre, नई दिल्ली, India", href: null, testid: "contact-address" },
      { text: "Test drive के लिए appointment लें — पहले email करके slot बुक कराएँ।", href: null, testid: null },
    ],
  },
  {
    icon: Clock3,
    title: "समय",
    lines: [
      { text: "सोमवार – शनिवार · 10:00 – 19:00", href: null, testid: "contact-hours" },
      { text: "रविवार बंद। Email 24×7 — क्रम से जवाब मिलेगा।", href: null, testid: null },
    ],
  },
];

export default function Contact() {
  return (
    <div className="mx-auto max-w-5xl px-5 pb-24 pt-40 sm:px-8" data-testid="contact-page">
      <Reveal className="text-center">
        <p className="eyebrow">Contact</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase text-white sm:text-5xl">
          बात <span className="text-gold-gradient">करें</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-neutral-400 sm:text-base">
          Booking, refund, test drive या कोई भी सवाल — हमसे email पर बात कीजिए।
          हम हर message का खुद जवाब देते हैं।
        </p>
      </Reveal>

      <Reveal className="mt-14">
        <div className="grid gap-5 md:grid-cols-3">
          {CARDS.map((c) => (
            <div key={c.title} className="card-glow rounded-2xl p-7">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#e6b800]/30 bg-[#e6b800]/10 text-[#e6b800]">
                <c.icon size={18} />
              </span>
              <h2 className="mt-5 font-display text-lg font-bold uppercase text-white">{c.title}</h2>
              <div className="mt-3 space-y-2">
                {c.lines.map((l, i) =>
                  l.href ? (
                    <a
                      key={i}
                      href={l.href}
                      data-testid={l.testid}
                      className="block text-sm font-semibold text-[#e6b800] transition-colors hover:text-[#ffc700]"
                    >
                      {l.text}
                    </a>
                  ) : (
                    <p key={i} data-testid={l.testid} className="text-sm leading-relaxed text-neutral-400">
                      {l.text}
                    </p>
                  )
                )}
              </div>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal className="mt-10">
        <div className="rounded-2xl border border-white/10 bg-[#0a0a0e] p-8 text-center">
          <p className="text-sm leading-relaxed text-neutral-400">
            Refund या cancellation के लिए email करें —{" "}
            <a href="mailto:support@ishukart.com" className="text-[#e6b800] hover:underline">
              support@ishukart.com
            </a>{" "}
            पर अपना <strong className="text-white">booking reference</strong> लिखना न भूलें। पूरी process{" "}
            <a href="/refund-policy" className="text-[#e6b800] hover:underline">
              Refund Policy
            </a>{" "}
            में देखें।
          </p>
        </div>
      </Reveal>
    </div>
  );
}
